module.exports = __webpack_public_path__ + "img/ico-windows.f0b04e7.svg";